import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import Logo from "../assets/images/PAYLOFT_LOGO.png";

import Migrate from "../assets/images/migrate.png";
import ProfilePhoto from "../assets/images/profile-photo.png";
import { useAuth } from "../context/AuthContextProvider";

const SettingsNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout, user, userrole } = useAuth();
  const [previewImage, setPreviewImage] = useState(null);
  const inactiveClass = "flex items-center py-2 px-5 gap-3 text-gray-400";
  const activeClass = "flex items-center py-2 px-5 gap-3 text-primary relative";
  //   const permissions = user.permissionList;

  const links = [
    // {
    //   to: "/settings/profile",
    //   name: "profile",
    //   text: "Profile",
    //   permission: "Upload Document",
    // },
    // {
    //   to: "/settings/business",
    //   name: "business",
    //   text: "Business",
    //   permission: "Update Business",
    // },
    // {
    //   to: "/settings/settlement",
    //   name: "settlement",
    //   text: "Settlement",
    //   permission: "Add Settlement Account",
    // },
  ];

  //   const filteredLinks = links.filter((link) =>
  //     permissions.includes(link.permission)
  //   );

  useEffect(() => {
    if (location.pathname === "/settings") {
      navigate("/settings/profile");
    }
  }, [location.pathname, navigate]);

  return (
    <div className="bg-arena-background h-full">
      <div className="flex">
        <div className="bg-white pt-4 w-[13%] h-[1047px] flex flex-col justify-between">
          <div className="flex flex-col items-center">
            <img
              src={window.__TENANT__?.logo ?? Logo}
              alt="logo"
              className="w-[150px] h-auto"
            />
            <div className="w-[191.98px] ">
              <NavLink className="flex items-center gap-3" to="/dashboard">
                <span>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.4">
                      <path
                        d="M2.35 12.35L5.14 15.14C5.46 15.46 6 15.24 6 14.79L6 13L20 13C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11L6 11L6 9.20997C6 8.75997 5.46 8.53997 5.15 8.85997L2.36 11.65C2.16 11.84 2.16 12.16 2.35 12.35Z"
                        fill="#030229"
                      />
                    </g>
                  </svg>
                </span>
                <p className="text-gray-400 text-[12px] font-semibold">
                  Main Menu
                </p>
              </NavLink>
              <p className="text-text-orange text-base font-semibold mt-4">
                Settings
              </p>

              <div className="">
                <NavLink
                  to="/settings/profile"
                  className={
                    location.pathname === "/settings/profile" ||
                    location.pathname.includes("/settings/profile")
                      ? activeClass
                      : inactiveClass
                  }
                >
                  <p className="text-base font-semibold">Profile</p>
                  {location.pathname === "/settings/profile" ||
                  location.pathname.includes("/settings/profile") ? (
                    <div className="absolute top-1/2 left-[65%] transform -translate-y-1/2 w-12 h-px bg-primary"></div>
                  ) : null}
                </NavLink>
                {/* {filteredLinks.map((link, index) => (
                  <NavLink
                    key={index}
                    to={link.to}
                    className={
                      location.pathname === link.to ||
                      location.pathname.includes(link.to)
                        ? activeClass
                        : inactiveClass
                    }
                  >
                    <p className="text-base font-semibold">{link.text}</p>
                    {location.pathname === link.to ||
                    location.pathname.includes(link.to) ? (
                      <div className="absolute top-1/2 left-[65%] transform -translate-y-1/2 w-12 h-px bg-text-orange"></div>
                    ) : null}
                  </NavLink>
                ))} */}
              </div>
            </div>
          </div>
          {/* <div className="flex items-center gap-2 py-2 px-5">
            <img
              src={ProfilePhoto}
              alt="profile-pic"
              className="w-[45px] h-[43px]"
            />
            <div>
              <p className="font-bold text-[12px] w-[54px]">
                {user.firstName} {user.lastName}
              </p>
              <p className="text-gray-400 text-[10px] font-semibold">
                {userrole.role}
              </p>
            </div>
            <svg
              onClick={logout}
              className="cursor-pointer"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.24596 8.35841C6.88138 8.35841 6.5931 8.64175 6.5931 9.00008C6.5931 9.35008 6.88138 9.64175 7.24596 9.64175H12.3332V13.6251C12.3332 15.6667 10.6459 17.3334 8.56016 17.3334H4.43104C2.35376 17.3334 0.666504 15.6751 0.666504 13.6334V4.37508C0.666504 2.32508 2.36224 0.666748 4.43952 0.666748H8.57712C10.6459 0.666748 12.3332 2.32508 12.3332 4.36675V8.35841H7.24596ZM15.3584 6.11692L17.7917 8.54192C17.9167 8.66692 17.9834 8.82525 17.9834 9.00025C17.9834 9.16692 17.9167 9.33359 17.7917 9.45025L15.3584 11.8753C15.2334 12.0003 15.0667 12.0669 14.9084 12.0669C14.7417 12.0669 14.575 12.0003 14.45 11.8753C14.2 11.6253 14.2 11.2169 14.45 10.9669L15.7834 9.64192H12.3334V8.35859H15.7834L14.45 7.03359C14.2 6.78359 14.2 6.37525 14.45 6.12525C14.7 5.86692 15.1084 5.86692 15.3584 6.11692Z"
                fill="#F58220"
              />
            </svg>
          </div> */}
        </div>
        <div className="w-full p-5">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default SettingsNav;
